<!-- Header -->
<div class="flex items-center justify-between px-6 py-4 border-b border-zinc-700">
  <h3 class="text-lg font-semibold text-white">Novo Comunicado</h3>
  <button
    mat-icon-button
    class="!text-white/60 hover:!text-white"
    (click)="cancelar()"
  >
    <mat-icon>close</mat-icon>
  </button>
</div>

<!-- Content -->
<form [formGroup]="form" class="px-6 py-5">
  <div class="flex flex-col gap-5">
    <!-- Título -->
    <mat-form-field appearance="outline" class="w-full">
      <mat-label>Título</mat-label>
      <input matInput formControlName="titulo" />
      <mat-error *ngIf="form.controls['titulo'].hasError('required')">
        Campo obrigatório
      </mat-error>
      <mat-error *ngIf="form.controls['titulo'].hasError('maxlength')">
        Máximo 100 caracteres
      </mat-error>
    </mat-form-field>

    <!-- Tipo de Destino -->
    <mat-form-field appearance="outline" class="w-full">
      <mat-label>Enviar para</mat-label>
      <mat-select formControlName="tipoDestino">
        <mat-select-trigger>
          <div class="flex items-center gap-2" *ngIf="opcaoDestinoSelecionada">
            <mat-icon class="text-white/70">{{ opcaoDestinoSelecionada.icone }}</mat-icon>
            <span>{{ opcaoDestinoSelecionada.nome }}</span>
          </div>
        </mat-select-trigger>
        <mat-option *ngFor="let opcao of opcoesDestino" [value]="opcao.id">
          <div class="flex items-center gap-2">
            <mat-icon>{{ opcao.icone }}</mat-icon>
            <span>{{ opcao.nome }}</span>
          </div>
        </mat-option>
      </mat-select>
    </mat-form-field>

    <!-- Seleção de Imobiliária (ADM_SISTEMA com destino IMOBILIARIA ou USUARIO) -->
    <mat-form-field *ngIf="isAdmSistema && (tipoDestinoSelecionado === 2 || tipoDestinoSelecionado === 3)" appearance="outline" class="w-full">
      <mat-label>Selecione a Imobiliária</mat-label>
      <input
        matInput
        [formControl]="imobiliariaCtrl"
        [matAutocomplete]="autoImob"
        (input)="filterImobiliarias($event)"
      />
      <mat-icon matSuffix class="text-white/50">search</mat-icon>
      <mat-autocomplete
        #autoImob="matAutocomplete"
        [displayWith]="displayImobiliariaFn"
        (optionSelected)="onImobiliariaSelected($event.option.value)"
      >
        <mat-option *ngFor="let imob of filteredImobiliarias" [value]="imob">
          {{ imob.nome }}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>

    <!-- Seleção de Usuário (quando destino é USUARIO) -->
    <ng-container *ngIf="tipoDestinoSelecionado === 3">
      <!-- Loading de usuários -->
      <div *ngIf="loadingUsuarios" class="flex items-center gap-2 text-white/60">
        <mat-spinner diameter="20"></mat-spinner>
        <span>Carregando usuários...</span>
      </div>

      <!-- Mensagem se não tiver imobiliária selecionada (ADM_SISTEMA) -->
      <p *ngIf="isAdmSistema && !imobiliariaCtrl.value && !loadingUsuarios" class="text-white/50 text-sm">
        Selecione uma imobiliária primeiro para ver os usuários.
      </p>

      <!-- Lista de usuários -->
      <mat-form-field *ngIf="!loadingUsuarios && usuarios.length > 0" appearance="outline" class="w-full">
        <mat-label>Selecione o Usuário</mat-label>
        <mat-select formControlName="usuarioDestinoId">
          <mat-option *ngFor="let usuario of usuarios" [value]="usuario.id">
            <div class="flex items-center gap-2">
              <mat-icon class="text-white/70">person</mat-icon>
              <span>{{ usuario.nome }}</span>
              <span class="text-white/50 text-sm ml-auto">{{ usuario.email }}</span>
            </div>
          </mat-option>
        </mat-select>
      </mat-form-field>

      <!-- Mensagem se não houver usuários -->
      <p *ngIf="!loadingUsuarios && usuarios.length === 0 && (isAdmImobiliaria || imobiliariaCtrl.value)" class="text-white/50 text-sm">
        Nenhum usuário encontrado na imobiliária.
      </p>
    </ng-container>

    <!-- Texto do Comunicado -->
    <mat-form-field appearance="outline" class="w-full">
      <mat-label>Texto do Comunicado</mat-label>
      <textarea matInput rows="5" formControlName="textoComunicado"></textarea>
      <mat-error *ngIf="form.controls['textoComunicado'].hasError('required')">
        Campo obrigatório
      </mat-error>
      <mat-error *ngIf="form.controls['textoComunicado'].hasError('maxlength')">
        Máximo 1000 caracteres
      </mat-error>
    </mat-form-field>

    <!-- Imagem (opcional) -->
    <div class="flex items-center gap-3 bg-zinc-800 rounded-lg px-4 py-3">
      <input #fileInput type="file" accept="image/*" (change)="onFileChange($event)" class="hidden" />
      <button mat-stroked-button type="button" class="!text-white !border-white/30 hover:!bg-white/10" (click)="fileInput.click()">
        <mat-icon class="mr-2">photo</mat-icon>
        Escolher imagem
      </button>
      <span *ngIf="imagemNome" class="text-white/70 text-sm">{{ imagemNome }}</span>
      <span *ngIf="!imagemNome" class="text-white/50 text-sm">Nenhuma imagem selecionada</span>
    </div>
  </div>
</form>

<!-- Footer -->
<div class="px-6 py-4 border-t border-zinc-700 flex justify-end gap-3">
  <button
    mat-flat-button
    class="!bg-zinc-700 !text-white"
    (click)="cancelar()"
    [disabled]="salvando"
  >
    Cancelar
  </button>
  <button
    mat-flat-button
    class="!bg-[#E4811E] !text-black font-semibold"
    (click)="salvar()"
    [disabled]="form.invalid || salvando"
  >
    <mat-spinner *ngIf="salvando" diameter="20" class="mr-2"></mat-spinner>
    {{ salvando ? 'Enviando...' : 'Enviar Comunicado' }}
  </button>
</div>